import { render, staticRenderFns } from "./SCardLaboratoyComp.vue?vue&type=template&id=4e42ea65&"
import script from "./SCardLaboratoyComp.vue?vue&type=script&lang=js&"
export * from "./SCardLaboratoyComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports